module.exports = __webpack_public_path__ + "static/media/Heart.18806004.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/404/Heart.svg
// module id = 2721
// module chunks = 68